import React from 'react';
import "../css/styles.css"
import "../css/Montserrat.css"
import "../css/Roboto.css"
import "../js/scripts.js"
import "../css/Course.css"

const CourseItem = ({ image, heading, hoverText }) => {
  return (
    <div className="col-lg-4 col-sm-6 mb-4">
      <div className="portfolio-item position-relative overflow-hidden">
        <div className="portfolio-link d-block position-relative">
          <div className="portfolio-hover d-flex flex-column justify-content-center align-items-center position-absolute w-100 h-100 top-0 start-0 px-3">
            <div className="hover-text mb-2 text-white">{hoverText}</div>
            <i className="fas fa-plus fa-3x text-white"></i>
          </div>
          <img className="img-fluid" src={image} alt={heading} />
        </div>
        <div className="portfolio-caption">
          <div className="portfolio-caption-heading">{heading}</div>
        </div>
      </div>
    </div>

  );
};

export default CourseItem;
